<template>
  <div>
    <main class="contact">
      <main-header fixed />
      <section class="contact__introduction contact__container" v-html="phrase"></section>

      <sui-loader v-show="fetching" size="large" class="general-loader" active centered inline />
      <filter-country
        v-show="!fetching"
        class="contact__filter"
        @onSelectFilter="filterContacts($event)"
      />

      <sui-grid
        v-show="!fetching"
        :columns="numberColumns"
        class="contact__addresses contact__container"
        centered
      >
        <sui-grid-row>
          <sui-grid-column>
            <h3 class="contact__addresses--title" v-html="$t('contact.talkwithus')"></h3>
          </sui-grid-column>
          <sui-grid-column>
            <sui-grid :columns="numberColumns" class="contact__addresses__contacts" centered>
              <sui-grid-row>
                <sui-grid-column :width="16">
                  <transition
                    enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    mode="out-in"
                  >
                    <div :key="33" v-show="visible">
                      <div v-show="currentFilter === 'all'">
                        <div class="contact__addresses__contacts__container">
                          <div class="contact__addresses__contacts__category">
                            {{ $t("contact.general") }}
                          </div>

                          <div class="contact__addresses__contacts__items">
                            <div
                              class="contact__addresses__contacts__item"
                              v-for="contact in generalContacts"
                              :key="contact.regional_name"
                            >
                              {{ contact.regional_name }} <br />
                              {{ contact.general_contact.phone }}<br />

                              <a
                                href="javascript:void(0)"
                                @click="sendEmail(contact.general_contact.email)"
                                :class="[{ translated: $i18n.locale !== 'en' }]"
                              >
                                {{ $t("generals.getcontact") }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-show="currentFilter !== 'all'">
                        <h3
                          class="contact--no-results"
                          v-show="Object.keys(filteredContact).length === 0"
                        >
                          {{ $t("generals.contactsfounded") }}
                        </h3>
                        <div
                          class="contact__addresses__contacts__container"
                          v-for="(contact, key) in filteredContact"
                          v-show="filteredContact.length !== 0"
                          :key="key"
                        >
                          <div class="contact__addresses__contacts__category">{{ key }}</div>

                          <div class="contact__addresses__contacts__items">
                            <div class="contact__addresses__contacts__item">
                              {{ contact.name }} <br />
                              {{ contact.phone }}<br />

                              <a
                                href="javascript:void(0)"
                                @click="sendEmail(contact.email)"
                                :class="[{ translated: $i18n.locale !== 'en' }]"
                              >
                                {{ $t("generals.getcontact") }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </sui-grid-column>
              </sui-grid-row>
            </sui-grid>
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>

      <filter-country
        v-show="!fetching"
        class="contact__filter"
        @onSelectFilter="filterVacancies($event)"
      />

      <sui-grid
        v-show="!fetching"
        :columns="numberColumns"
        class="contact__work-with contact__container"
        centered
      >
        <sui-grid-row>
          <sui-grid-column>
            <h3 class="contact__work-with--title" v-html="$t('contact.workwithus')"></h3>
          </sui-grid-column>
          <sui-grid-column>
            <sui-grid :columns="numberColumns" class="contact__work-with__introduction">
              <sui-grid-row>
                <sui-grid-column
                  :computer="6"
                  :mobile="16"
                  class="contact__work-with__introduction__category"
                >
                  {{ $t("contact.talents") }}
                </sui-grid-column>
                <sui-grid-column>
                  <p v-html="$t('contact.talentdescription')"></p>
                  <!-- <a href="#" :class="[{ translated: $i18n.locale !== 'en' }]">
                    {{ $t("generals.getcontact") }}
                  </a> -->
                </sui-grid-column>
              </sui-grid-row>
            </sui-grid>
          </sui-grid-column>
        </sui-grid-row>
      </sui-grid>

      <related-news
        title=""
        class="contact__jobs"
        :buttonText="$t('generals.apply')"
        :items="jobs"
        linkExternal
        v-show="!fetching"
        :fetching="fetchingVacancies"
        isVacancies
      />
      <scroll-to />
    </main>

    <main-footer v-show="footerVisible" ref="footer" />
  </div>
</template>

<script>
import RelatedNews from "@/components/news/related-news";

export default {
  name: "contact",
  components: {
    RelatedNews,
  },
  data() {
    return {
      footerVisible: false,
      visible: true,
      numberColumns: 2,
      currentFilter: "all",
      generalContacts: [],
      filteredContact: [],
      fetching: true,
      fetchingVacancies: true,
      phrase: "",
      jobs: [],
      contacts: [],
    };
  },

  mounted() {
    setTimeout(() => {
      this.footerVisible = true;
    }, 800);

    this.setColumnSize();
    this.getData();

    $(window).on("resize", () => {
      this.setColumnSize();
    });

    this.$hub.$on("setLanguage", () => {
      const filtered = this.contacts.find((item) => item.regional_name === this.currentFilter);
      this.filteredContact = this.mountContacts(filtered);
    });

    this.$hub.$on("repeatRequests", (language) => {
      this.getData(language);
    });
  },

  methods: {
    getData(language = this.$store.state.ui.language) {
      this.fetching = true;

      this.$contact
        .get(language)
        .then((resolve) => {
          this.contacts = resolve.data.contacts;
          this.phrase = resolve.data.phrase;
          this.createGeneralContacts();
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .catch(() => {
          document.dispatchEvent(new Event("prerender-ready"));
        })
        .finally(() => {
          this.fetching = false;
        });

      this.getVacancies(language);
    },

    getVacancies(language, filter) {
      this.fetchingVacancies = true;

      this.$contact
        .jobs(language, filter)
        .then((resolve) => {
          this.jobs = resolve.data.data.items;
        })
        .finally(() => {
          this.fetchingVacancies = false;
        });
    },

    setColumnSize() {
      const wWidth = $(window).width();

      if (wWidth < 1000) {
        this.numberColumns = 1;
        return;
      }

      this.numberColumns = 2;
    },

    createGeneralContacts() {
      const generalContacts = [];

      this.contacts.forEach((item) => {
        generalContacts.push({
          regional_name: item.regional_name,
          general_contact: item.general_contact,
        });
      });

      this.generalContacts = generalContacts;
    },

    filterContacts(obj) {
      const filtered = this.contacts.find((item) => item.regional_name === obj.value);
      this.visible = false;

      setTimeout(() => {
        this.filteredContact = this.mountContacts(filtered);
      }, 400);

      setTimeout(() => {
        this.currentFilter = obj.value;
        this.visible = true;
      }, 700);
    },

    filterVacancies(obj) {
      this.getVacancies(this.$store.state.ui.language, obj.id);
    },

    mountContacts(obj) {
      let newObj = {};

      if (obj?.items) {
        newObj = { ...obj.items };
      }

      // eslint-disable-next-line camelcase
      if (obj?.general_contact) {
        const key = this.$t("contact.general");
        newObj = { ...newObj, [key]: obj.general_contact };
      }

      return newObj;
    },

    sendEmail(email) {
      window.location.href = `mailto:${email}`;
    },
  },
};
</script>

<style lang="scss">
@import "./styles/contact";
</style>
